/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import styled from "styled-components";
import { Input2, DropDown2, DecimalInput } from "components";
import { useInput } from "hooks";
import { ALL_COUPON_TYPES_TEXT_PREFIXED } from "config";

export const OfferUpTextBuilder = ({
  className,
  value,
  onChange = () => {},
}) => {
  const variation = useInput("& Up");
  const type = useInput("$");
  const val = useInput("5");
  const couponType = useInput("");

  const variationData = [
    { id: "& Up", title: "& Up" },
    { id: "& below", title: "& below" },
    { id: "starting @", title: "starting @" },
    { id: "less than", title: "less than" },
    { id: "up to", title: "up to" },
    { id: "starting under", title: "starting under" },
    { id: "save up to", title: "save up to" },
  ];

  const typeData = [
    { id: "$", title: "$" },
    { id: "%", title: "%" },
  ];

  const handleUpdateValue = (variation, type, val, coupon) => {
    if (variation && type && val) {
      const typeval = type === '$' ? `${type}${val}` : `${val}${type}`;
      const couponSuffix = coupon ? ` ${coupon}` : '';
      switch (variation) {
        case "& Up":
          onChange(`${typeval} & Up${couponSuffix}`);
          break;
        case "& below":
          onChange(`${typeval} & Below${couponSuffix}`);
          break;
        case "starting @":
          onChange(`starting @ ${typeval}${couponSuffix}`);
          break;
        case "less than":
          onChange(`Less Than ${typeval}${couponSuffix}`);
          break;
        case "up to":
          onChange(`up to ${typeval}${couponSuffix}`);
          break;
        case "starting under":
          onChange(`Starting under ${typeval}${couponSuffix}`);
          break;
        case "save up to":
          onChange(`Save Up To ${typeval}${couponSuffix}`);
          break;

        default:
          break;
      }
    }
  };

  useEffect(() => {
    if (value) {
      // Extract coupon suffix if present
      const couponMatch = value.match(/ (w\/(?:digital |manufacturer's |Sunday )?coupon)$/i);
      const couponSuffix = couponMatch ? couponMatch[1] : "";
      couponType.setValue(couponSuffix);
      
      // Remove coupon suffix for parsing the main offer text
      const cleanValue = couponSuffix ? value.replace(` ${couponSuffix}`, '') : value;
      
      const extractValue = (regex, variationString) => {
        const match = cleanValue.match(regex);
        if (match) {
          // eslint-disable-next-line 
          const [_, typeChar, valuePart] = match;
          type.setValue(typeChar);
          val.setValue(valuePart);
          variation.setValue(variationString);
        }
      };
  
      if (cleanValue.match(/& up/i)) {
        extractValue(/^(\$|%)(\d+\.?\d*)\s&\sup$/i, "& Up");
      } else if (cleanValue.match(/& below/i)) {
        extractValue(/^(\$|%)(\d+\.?\d*)\s&\sbelow$/i, "& below");
      } else if (cleanValue.match(/^starting @/i)) {
        extractValue(/^starting\s@\s(\$|%)(\d+\.?\d*)$/i, "starting @");
      } else if (cleanValue.match(/^less than/i)) {
        extractValue(/^less\sthan\s(\$|%)(\d+\.?\d*)$/i, "less than");
      } else if (cleanValue.match(/^up to/i)) {
        extractValue(/^up\sto\s(\$|%)(\d+\.?\d*)$/i, "up to");
      } else if (cleanValue.match(/^starting under/i)) {
        extractValue(/^starting\sunder\s(\$|%)(\d+\.?\d*)$/i, "starting under");
      } else if (cleanValue.match(/^save up to/i)) {
        extractValue(/^save\sup\sto\s(\$|%)(\d+\.?\d*)$/i, "save up to");
      }
    }
  }, [value]);
  
  return (
    <div className={`${className} mt-1 p-2`}>
      <Title>Offer Text Builder</Title>
      <Container className="mt-2">
        <div style={{ width: 120, marginRight: 20 }}>
          <DropDown2
            label="Variation"
            value={variation.value}
            width={120}
            onChange={(e) => {
              variation.setValue(e);
              handleUpdateValue(e, type.value, val.value, couponType.value);
            }}
            data={variationData}
          />
        </div>
        <div style={{ width: 60, marginRight: 20 }}>
          <DropDown2
            label="Type"
            value={type.value}
            width={60}
            onChange={(e) => {
              type.setValue(e);
              // Clear value when switching to % to avoid decimal issues
              if (e === "%" && type.value === "$" || e === "$" && type.value === "%") {
                val.setValue("");
                handleUpdateValue(variation.value, e, "", couponType.value);
              } else {
                handleUpdateValue(variation.value, e, val.value, couponType.value);
              }
            }}
            data={typeData}
          />
        </div>
        <div style={{ width: 120, marginRight: 20 }}>
          {type.value === "$" ? (
            <DecimalInput
              label="Value"
              prefix="$"
              value={val.value}
              onChange={(e) => {
                val.setValue(e);
                handleUpdateValue(variation.value, type.value, e, couponType.value);
              }}
            />
          ) : (
            <Input2
              label="Value"
              type="int"
              value={val.value}
              onChange={(e) => {
                val.setValue(e);
                handleUpdateValue(variation.value, type.value, e, couponType.value);
              }}
            />
          )}
        </div>
      </Container>
      <Container className="mt-2">
        <div style={{ width: 200 }}>
          <DropDown2
            label="Coupon"
            value={couponType.value}
            width={200}
            onChange={(e) => {
              couponType.setValue(e);
              handleUpdateValue(variation.value, type.value, val.value, e);
            }}
            data={ALL_COUPON_TYPES_TEXT_PREFIXED}
          />
        </div>
      </Container>
    </div>
  );
};

const Title = styled.div`
  color: #66c0e1;
  font-size: 16px;
`;
const Container = styled.div`
  background: ${(props) => props.theme.palette.items};
  padding: 8px;
  display: flex;
`;
